module.exports = __webpack_public_path__ + "img/symbol_4.4b29590a.png";